import { useEffect, useContext, useState } from "react";
import "../style/RecoverPassword.module.scss";
import "react-phone-input-2/lib/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { AuthContext } from "../../../context/AuthContext";
import { usePhoneFormat } from "../../../hooks/usePhoneFormat";
import * as Yup from 'yup';



export function useRecoverPassword() {

    const { PasswordRecoveryToken } = useContext(AuthContext);
    const { validateLocalPhone } = usePhoneFormat();

    const route = useNavigate();
    const parameters = useLocation();

    const validate = Yup.object({
        phoneNumber: Yup.number().typeError('Ingrese un número de celular válido')
            .required('Número de celular requerido')
            .test('Validate Phone Number', 'Ingrese un número de celular válido', value => validateLocalPhone('+' + value) == true),
    })

    const formik = useFormik({
        initialValues: {
            phoneNumber: "",
        },
        onSubmit: async (values) => {
            const res = await PasswordRecoveryToken(values.phoneNumber);
            if (res.status == "OTP_COMPLETED") {
                route("/NewRecoverPassword", {
                    state: {
                        phoneNumber: values.phoneNumber,
                    },
                });
            }

            if (res.status == "OTP_PENDING") {
                Swal.fire({
                    showCloseButton: true,
                    title: 'Advertencia',
                    text: "OTP pendiente",
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#fd6e0d',
                    iconColor: "#fd6e0d",
                    confirmButtonText: 'Entendido'
                }).then((result) => {
                    if (result.isConfirmed) {
                        route("/SignUpOTPScreen", {
                            state: {
                                screen: "RecoverPassword",
                                phoneNumber: values.phoneNumber,
                                accessToken: localStorage.getItem('registerToken'),
                            },
                        });
                    }
                });
            }

            if (res.status == "PHONE_NUMBER_DOES_NOT_EXIST") {
                Swal.fire({
                    showCloseButton: true,
                    title: 'Advertencia',
                    text: "Número no registrado",
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#fd6e0d',
                    iconColor: "#fd6e0d",
                    confirmButtonText: 'Entendido'
                }).then((result) => {
                    if (result.isConfirmed) {
                        formik.setFieldValue("phoneNumber", "");
                    }
                });
            }
        },
        validationSchema: validate

    });

    return {
        formik,
        parameters,
        route
    }
}